import constants from 'constants';

const {
  ADD_SPONSORS,
  ADD_ADMIN_SPONSORS,
  CLEAN_SPONSORS,
  SET_TEMP_SPONSOR,
  SET_SPONSORS
} = constants;

const sponsors = (sponsors = {
    list: {
      values: [],
      isLoaded: false
    },
    admin: {
      list: {
        values: [],
        page: 0,
        pages: 0,
        total_pages: 0,
        query: {
          title: '',
          order: {
            created_at: 'desc'
          }
        }
      },
      tmp: {}
    }
  }, {
    type,
    payload
  }) => {
  switch(type) {
    case ADD_SPONSORS:
      return { ...sponsors,
        ...{
          list: {
            values: payload.values,
            isLoaded: true
          }
        }
      }
    case ADD_ADMIN_SPONSORS:
      return { ...sponsors,
        ...{
          admin: {
            ...sponsors.admin,
            list: {
              values: payload.values,
              page: payload.page,
              total_pages: payload.total_pages,
              count: payload.count
            }
          }
        }
      }
    case SET_SPONSORS:
      return { ...sponsors,
        ...{
          list: {
            ...sponsors.list,
            values: payload
          }
        }
      }
    case CLEAN_SPONSORS:
      return {
        ...sponsors,
        admin: {
          ...sponsors.admin,
          list: {
            values: [],
            page: 0,
            pages: 0,
            total_pages: 0,
            query: {
              title: '',
              order: {
                created_at: 'desc'
              }
            }
          },
          tmp: {}
        }
      }
    case SET_TEMP_SPONSOR:
      return {
        ...sponsors,
        admin: {
          ...sponsors.admin,
          tmp: payload.sponsor
        }
      }
    default: return sponsors
  }
}

export { sponsors };



/** WEBPACK FOOTER **
 ** ./src/reducers/sponsors.js
 **/